import "./App.css";
import Router from "./Routers/Router";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
